import { ProgressBarProps } from 'components/ProgressBar';
import { SecurityActionType } from '../../type';

const modifyText = {
    modifyEmail: __('验证新邮箱'),
    modifyPhone: __('验证新手机号'),
    modifyPassword: __('设置新密码'),
    upgradePassword: __('设置新密码')
};

export function getStepsOptions(type: SecurityActionType): ProgressBarProps['steps'] {
    if (type === 'mfaEnable') {
        return [
            {
                title: __('安装TradeUP Authenticator')
            },
            {
                title: __('帐号关联')
            },
            {
                title: __('身份验证')
            },
            {
                title: __('验证并开启')
            }
        ];
    }

    if (type === 'activeEmail') {
        return [
            {
                title: __('验证邮箱')
            },
            {
                title: __('完成验证')
            }
        ];
    }

    if (type === 'linkAccount') {
        return [
            {
                title: __('验证登录信息')
            },
            {
                title: __('身份验证')
            },
            {
                title: __('Retrieve the Initial Password')
            }
        ];
    }

    if (type === 'bindEmail' || type === 'bindPhone') {
        return [
            {
                title: __('验证登录信息')
            },
            {
                title: type === 'bindPhone' ? __('验证新手机号') : __('验证新邮箱')
            },
            {
                title: __('认证成功')
            }
        ];
    }

    if (type === 'upgradePassword') {
        return [
            {
                title: __('身份验证')
            },
            {
                title: modifyText[type]
            },
            {
                title: __('Update successfully')
            }
        ];
    }

    return [
        {
            title: __('验证登录信息')
        },
        {
            title: __('身份验证')
        },
        {
            title: modifyText[type]
        },
        {
            title: __('修改成功')
        }
    ];
}
